module.exports = __webpack_public_path__ + "static/media/QuizzAppFeedback.636c3fea.PNG";